import React from "react";
import { Check } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const FLAGS = {
  en: "🇬🇧",
  it: "🇮🇹",
  pl: "🇵🇱",
};

const NAMES = {
  en: "English",
  it: "Italiano",
  pl: "Polski",
};

export function LanguageSwitcher({ variant = "default" }) {
  const { locale, setLocale } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          data-testid="language-switcher-trigger"
          className="gap-1.5 rounded-full px-2 sm:gap-2 sm:px-3 hover:bg-slate-100 dark:hover:bg-slate-800/60"
        >
          <span className="text-base leading-none">{FLAGS[locale]}</span>
          <span className="hidden text-xs font-semibold uppercase tracking-wider sm:inline">
            {locale}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {Object.keys(FLAGS).map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLocale(code)}
            data-testid={`language-option-${code}`}
            className="gap-3 cursor-pointer"
          >
            <span className="text-lg">{FLAGS[code]}</span>
            <span className="flex-1">{NAMES[code]}</span>
            {locale === code && (
              <Check className="h-4 w-4 text-[#9ACD32]" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
